import React, { FC } from 'react'
import { muiBankTheme, Link } from '@ally/metronome-ui'
import styled from 'styled-components'
import OpenAccountButton from '../OpenAccountButton'
import { AdobeTileContent } from '../../types'
import XLTileGroup from './XLTileGroup'

const ProductsRatesLink = styled(Link)`
  white-space: normal;
  max-width: 180px;
  padding-right: ${muiBankTheme.space.sm};
`

const FadeInWrapper = styled.nav`
  display: flex;
  align-items: center;
  width: 100%;
  max-width: 1100px;
  padding: 0 ${muiBankTheme.space.sm};
  margin: 0 auto;
  opacity: 1;
  animation-fill-mode: forwards;
  animation: fadeIn ease-in 5s;
  -webkit-animation: fadeIn ease 5s;
  -moz-animation: fadeIn ease-in 5s;
  -o-animation: fadeIn ease-in 5s;
  -ms-animation: fadeIn ease-in 5s;

  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  @-moz-keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  @-webkit-keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  @-o-keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  @-ms-keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
`
interface ComponentProps {
  AboveAppPortal: FC
  exploreTiles: AdobeTileContent | null
}

const XLExploreTiles: FC<ComponentProps> = React.memo(
  ({ AboveAppPortal, exploreTiles }) => {
    return exploreTiles ? (
      <FadeInWrapper
        aria-label="Innovative options make reaching your goals possible"
        // eslint-disable-next-line no-underscore-dangle
        data-track-offerid={exploreTiles._id || null}
        data-track-mbox="ally-dashboard-explore-tiles"
      >
        <ProductsRatesLink to="/products-and-rates" text={exploreTiles.title} />
        <XLTileGroup data={exploreTiles} />
        <OpenAccountButton />
      </FadeInWrapper>
    ) : null
  },
)

export default XLExploreTiles
